import apiempresaweb from '@/services/api-varejoweb';
import db from '@/plugins/dexie';
import { empresa as formatEmpresa } from '@/utils/local/tabelas';

export default {
  namespaced: true,

  state: {
    list: [],
    dados: null,
  },

  getters: {
    list: (state) => state.list,
    dados: (state) => {
      if (state.dados) return state.dados;
      try {
        const stored = sessionStorage.getItem('empresa:dados');
        if (stored) return JSON.parse(stored);
      } catch (e) {
        console.error('Erro ao recuperar dados da empresa do sessionStorage:', e);
      }
      return null;
    },
    osPedeDadosEquipamento: (state, getters) => {
      const empresaDados = getters.dados;
      if (!empresaDados) return 'N';
      const val = empresaDados.OSPedeDadosEquipamento ?? empresaDados.ospededadosequipamento ?? empresaDados.OSPEDEDADOSEQUIPAMENTO ?? empresaDados.empospededadosequipamento ?? 'N';
      return String(val).toUpperCase().trim();
    },
    nomeLivre1OS: (state, getters) => {
      const empresaDados = getters.dados;
      if (!empresaDados) return '';
      return (empresaDados.empnomelivre1os ?? empresaDados.NomeLivre1OS ?? empresaDados.nomelivre1os ?? empresaDados.NOMELIVRE1OS ?? '').trim();
    },
    nomeLivre2OS: (state, getters) => {
      const empresaDados = getters.dados;
      if (!empresaDados) return '';
      return (empresaDados.empnomelivre2os ?? empresaDados.NomeLivre2OS ?? empresaDados.nomelivre2os ?? empresaDados.NOMELIVRE2OS ?? '').trim();
    },
    nomeLivre3OS: (state, getters) => {
      const empresaDados = getters.dados;
      if (!empresaDados) return '';
      return (empresaDados.empnomelivre3os ?? empresaDados.NomeLivre3OS ?? empresaDados.nomelivre3os ?? empresaDados.NOMELIVRE3OS ?? '').trim();
    },
    osPedeTecnicoVerificacao: (state, getters) => {
      const empresaDados = getters.dados;
      if (!empresaDados) return null;
      return empresaDados.OSPedeTecnicoVerificacao ?? empresaDados.ospedetecnicoverificacao ?? empresaDados.empospedetecnicoverificacao ?? null;
    },
    pedeTecFechaOS: (state, getters) => {
      const empresaDados = getters.dados;
      if (!empresaDados) return null;
      return empresaDados.PedeTecFechaOS ?? empresaDados.pedetecfechaos ?? empresaDados.emppedetecfechaos ?? null;
    },
    pedeTecnicoItemOS: (state, getters) => {
      const empresaDados = getters.dados;
      if (!empresaDados) return null;
      return empresaDados.PedeTecnicoItemOS ?? empresaDados.pedetecnicoitemos ?? empresaDados.emppedetecnicoitemos ?? null;
    },
    pedeValorTecnicoItemOS: (state, getters) => {
      const empresaDados = getters.dados;
      if (!empresaDados) return null;
      return empresaDados.emppedevalortecnicoitemos ?? empresaDados.PedeValorTecnicoItemOS ?? empresaDados.pedevalortecnicoitemos ?? null;
    },
    pedeValorAcrescimoPreVenda: (state, getters) => {
      const empresaDados = getters.dados;
      if (!empresaDados) return null;
      return empresaDados.PEDEVALORACRESCIMOPREVENDA ?? empresaDados.pedevaloracrescimoprevenda ?? empresaDados.emppedevaloracrescimoprevenda ?? null;
    },
    pedeTecnicoRetirouPeca: (state, getters) => {
      const empresaDados = getters.dados;
      if (!empresaDados) return null;
      return empresaDados.emppedetecnicoretiroupeca ?? empresaDados.PedeTecnicoRetirouPeca ?? empresaDados.pedetecnicoretiroupeca ?? null;
    },
    qtdeTecnicosOS: (state, getters) => {
      const empresaDados = getters.dados;
      if (!empresaDados) return 1;
      const val = empresaDados.empqtdetecnicosos ?? empresaDados.QtdeTecnicosOS ?? empresaDados.qtdeTecnicosOS ?? empresaDados.QTDETECNICOSOS ?? 1;
      const num = parseInt(val);
      return !isNaN(num) && num > 0 ? (num > 3 ? 3 : num) : 1;
    },
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find({ commit }, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('empresa/dados', { params: { ...where, ...params } }),
      ]);

      const empresaData = Array.isArray(data) ? data[0] : data;
      if (empresaData) {
        commit('SET_DADOS', empresaData);
      }

      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_DADOS(state, dados) {
      if (dados) {
        try {
          const formatted = formatEmpresa(dados);
          state.dados = formatted;
          sessionStorage.setItem('empresa:dados', JSON.stringify(formatted));
          const idEmpresa = formatted.empidempresa ?? formatted.empidnuvem ?? null;
          if (idEmpresa) {
            sessionStorage.setItem('ID_Empresa', idEmpresa);
          }
          const empData = {
            ...formatted,
            empdataalteracao: formatted.empdataalteracao || dados.empdataalteracao || dados.dataalteracao || new Date().toISOString(),
          };
          db.empresa.toCollection().first().then((empLocal) => {
            if (empLocal && empLocal.id) {
              db.empresa.update(empLocal.id, empData);
            } else {
              db.empresa.put(empData);
            }
          }).catch(e => console.warn('Erro ao atualizar Dexie empresa:', e));
        } catch (e) {
          console.error('Erro ao salvar dados da empresa no sessionStorage:', e);
        }
      } else {
        state.dados = null;
      }
    },
  },
};
